import { Text, TextProps } from "@chakra-ui/layout";
import * as React from "react";

export const Copyright = (props: TextProps) => (
  <Text fontSize="m" style={{ fontWeight: "bold", color: "#FFF" }} {...props}>
    &copy; {new Date().getFullYear()} Xlung.net
  </Text>
);
